export default {
  setCollections(state, collections) {
    state.collections = collections;
  },
  setPagination(state, pagination) {
    state.homePagination = pagination;
  },
  setContentCollections(state, content) {
    state.contentCollections = content;
  },
  setBanners(state, banners) {
    state.banners = banners;
  },
};
